/** Shared API base URL for admin portal (local dev vs production). */
const PRODUCTION_API_BASE = 'https://rehman-travels-api.onrender.com/api';
const LOCAL_API_BASE = 'http://localhost:5000/api';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'development' ? LOCAL_API_BASE : PRODUCTION_API_BASE);

export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/i, '');
